/*
 * Modern Standard Coffee — slide-in basket (draft 29, 17 Oct 2026)
 *
 * Markup: sections/msc-basket-drawer.liquid (rendered in layout/theme.liquid).
 *
 * - Opens when the header basket icon is tapped, and after any successful
 *   add to basket (product page form, sticky bar, quick add, Dawn product
 *   forms, app widgets) — it watches fetch / XHR calls to /cart/add.
 * - Product pages using the msc-so buy box post a plain <form action="/cart/add">.
 *   That submit is sent with fetch instead, using the form's own FormData, so
 *   grind, quantity, Recharge's selling plan and gift fields go exactly as
 *   before. If fetch fails outright the form falls back to a normal submit.
 * - Quantity / remove / the add-on tile re-render the drawer through the
 *   Section Rendering API; nothing reloads.
 * - Stays out of the way on /cart (the basket page manages itself).
 */
(function () {
  if (window.__mscBasketDrawer) return;
  window.__mscBasketDrawer = true;

  var SECTION = 'msc-basket-drawer';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var ON_CART_PAGE = /\/cart\/?$/.test(window.location.pathname);
  var OWN = 'X-MSC-Basket-Drawer';
  var nativeFetch = window.fetch ? window.fetch.bind(window) : null;
  var lastFocus = null;
  var busy = false;

  function el() { return document.querySelector('[data-msc-bd]'); }
  function panel() { var r = el(); return r && r.querySelector('[data-msc-bd-panel]'); }
  function isOpen() { var r = el(); return !!(r && r.classList.contains('is-open')); }

  function pathOf(url) {
    try { return new URL(url, window.location.origin).pathname; } catch (e) { return ''; }
  }
  function isAdd(url) { return /\/cart\/add(\.js)?$/.test(pathOf(url)); }
  function isWrite(url) { return /\/cart\/(add|change|update|clear)(\.js)?$/.test(pathOf(url)); }

  // ---- Render --------------------------------------------------------------

  function fetchSections() {
    return nativeFetch(ROOT + '?sections=' + SECTION + ',cart-icon-bubble', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    }).then(function (r) { return r.json(); });
  }

  function applySections(data) {
    var doc;
    if (data && data[SECTION]) {
      doc = new DOMParser().parseFromString(data[SECTION], 'text/html');
      var fresh = doc.querySelector('[data-msc-bd-panel]');
      var cur = panel();
      if (fresh && cur) {
        var active = document.activeElement;
        var key = active && cur.contains(active) ? focusKey(active) : null;
        cur.innerHTML = fresh.innerHTML;
        if (key) restoreFocus(key);
      }
    }
    if (data && data['cart-icon-bubble']) {
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble) {
        doc = new DOMParser().parseFromString(data['cart-icon-bubble'], 'text/html');
        var inner = doc.querySelector('.shopify-section') || doc.body;
        bubble.innerHTML = inner.innerHTML;
      }
    }
  }

  function focusKey(node) {
    if (node.hasAttribute('data-msc-bd-qty')) {
      var line = node.getAttribute('data-msc-bd-line');
      var dir = node.classList.contains('msc-bd__remove') ? 'remove'
        : (node.getAttribute('aria-label') || '').indexOf('Increase') === 0 ? 'up' : 'down';
      return { line: line, dir: dir };
    }
    if (node.hasAttribute('data-msc-bd-close')) return { close: true };
    return null;
  }

  function restoreFocus(key) {
    var p = panel();
    if (!p) return;
    var target = null;
    if (key.close) target = p.querySelector('.msc-bd__close');
    else if (key.line) {
      var btns = p.querySelectorAll('[data-msc-bd-line="' + key.line + '"]');
      if (btns.length) target = key.dir === 'up' ? btns[1] : key.dir === 'remove' ? btns[2] : btns[0];
    }
    (target || p).focus();
  }

  function refresh() {
    if (!nativeFetch) return Promise.resolve();
    return fetchSections().then(applySections).catch(function () {});
  }

  function setStatus(text) {
    var s = panel() && panel().querySelector('[data-msc-bd-status]');
    if (s) s.textContent = text;
  }

  // ---- Open / close ----------------------------------------------------------

  function hideNotification() {
    var cn = document.querySelector('cart-notification');
    if (cn && typeof cn.close === 'function') { try { cn.close(); } catch (e) {} }
  }

  function open(opener) {
    var r = el();
    if (!r || ON_CART_PAGE) return;
    hideNotification();
    if (!isOpen()) lastFocus = opener || document.activeElement;
    r.hidden = false;
    document.documentElement.classList.add('msc-bd-lock');
    requestAnimationFrame(function () {
      r.classList.add('is-open');
      var p = panel();
      if (p && !p.contains(document.activeElement)) p.focus();
    });
  }

  function close() {
    var r = el();
    if (!r || !isOpen()) return;
    r.classList.remove('is-open');
    document.documentElement.classList.remove('msc-bd-lock');
    setTimeout(function () { if (!isOpen()) r.hidden = true; }, 260);
    if (lastFocus && document.contains(lastFocus) && lastFocus.focus) lastFocus.focus();
  }

  function refreshAndOpen() {
    if (ON_CART_PAGE || !el()) return;
    refresh().then(function () { open(); setStatus('Added to your basket'); });
  }

  window.mscBasketDrawer = { enabled: !ON_CART_PAGE, open: open, close: close, refresh: refresh };

  // ---- Watch cart writes from anything on the page --------------------------

  if (nativeFetch) {
    var wrapped = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var own = init && init.headers && init.headers[OWN];
      var promise = wrapped.apply(window, arguments);
      if (!own && isWrite(url)) {
        promise.then(function (res) {
          if (!res || !res.ok) return;
          if (isAdd(url)) refreshAndOpen();
          else if (el()) refresh();
        }).catch(function () {});
      }
      return promise;
    };
  }
  if (window.XMLHttpRequest) {
    var xopen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      var u = String(url);
      if (isWrite(u)) {
        this.addEventListener('load', function () {
          if (this.status < 200 || this.status >= 300) return;
          if (isAdd(u)) refreshAndOpen(); else if (el()) refresh();
        });
      }
      return xopen.apply(this, arguments);
    };
  }

  // ---- Product forms that would otherwise post and leave the page ----------

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!nativeFetch || ON_CART_PAGE || !el()) return;
    if (!form || form.tagName !== 'FORM' || e.defaultPrevented) return;
    var action = form.getAttribute('action') || '';
    if (!isAdd(action)) return;
    if (form.closest('product-form') || form.hasAttribute('data-msc-bd-skip')) return;
    e.preventDefault();

    var btn = form.querySelector('[type="submit"]');
    var errorEl = form.querySelector('[data-so-error]');
    if (errorEl) errorEl.hidden = true;
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.classList.add('is-adding'); }

    var headers = { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
    headers[OWN] = '1';
    nativeFetch(ROOT + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: headers,
      body: new FormData(form)
    })
      .then(function (r) {
        return r.json().then(function (j) { return { ok: r.ok, body: j }; });
      })
      .then(function (res) {
        if (!res.ok) {
          var msg = (res.body && (res.body.description || res.body.message)) || 'Sorry, that didn’t work. Please try again.';
          if (errorEl) { errorEl.textContent = msg; errorEl.hidden = false; }
          else window.alert(msg);
          return;
        }
        if (window.mscRefreshCartMessages) window.mscRefreshCartMessages();
        refreshAndOpen();
      })
      .catch(function () {
        HTMLFormElement.prototype.submit.call(form);
      })
      .finally(function () {
        if (btn) { btn.removeAttribute('aria-busy'); btn.classList.remove('is-adding'); }
      });
  });

  // ---- Header basket icon ---------------------------------------------------

  document.addEventListener('click', function (e) {
    var icon = e.target.closest && e.target.closest('#cart-icon-bubble');
    if (!icon || ON_CART_PAGE || !el()) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
    e.preventDefault();
    e.stopPropagation();
    open(icon);
    refresh();
  }, true);

  // ---- Inside the drawer -----------------------------------------------------

  function change(line, qty) {
    if (busy) return;
    busy = true;
    var p = panel();
    if (p) p.classList.add('is-busy');
    var headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
    headers[OWN] = '1';
    window.fetch(ROOT + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: headers,
      body: JSON.stringify({ line: parseInt(line, 10), quantity: Math.max(0, parseInt(qty, 10) || 0) })
    })
      .then(function (r) {
        return r.json().then(function (j) { if (!r.ok) throw j; return j; });
      })
      .then(function () { return refresh(); })
      .then(function () { setStatus(qty === '0' ? 'Item removed' : 'Basket updated'); })
      .catch(function (err) { showError(err); refresh(); })
      .finally(function () {
        busy = false;
        var p2 = panel();
        if (p2) p2.classList.remove('is-busy');
      });
  }

  function addVariant(id) {
    if (busy) return;
    busy = true;
    var p = panel();
    if (p) p.classList.add('is-busy');
    var headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
    headers[OWN] = '1';
    window.fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: headers,
      body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1, properties: { _addon: 'drawer' } }] })
    })
      .then(function (r) {
        return r.json().then(function (j) { if (!r.ok) throw j; return j; });
      })
      .then(function () { return refresh(); })
      .then(function () { setStatus('Added to your basket'); })
      .catch(function (err) { showError(err); })
      .finally(function () {
        busy = false;
        var p2 = panel();
        if (p2) p2.classList.remove('is-busy');
      });
  }

  function showError(err) {
    var box = panel() && panel().querySelector('[data-msc-bd-error]');
    if (!box) return;
    box.textContent = (err && (err.description || err.message)) || 'Sorry, that didn’t work. Please try again.';
    box.hidden = false;
  }

  document.addEventListener('click', function (e) {
    var r = el();
    if (!r || !r.contains(e.target)) return;
    var t = e.target.closest('[data-msc-bd-close], [data-msc-bd-qty], [data-msc-bd-add]');
    if (!t) return;
    if (t.hasAttribute('data-msc-bd-close')) { e.preventDefault(); close(); return; }
    if (t.hasAttribute('data-msc-bd-qty')) {
      e.preventDefault();
      change(t.getAttribute('data-msc-bd-line'), t.getAttribute('data-msc-bd-qty'));
      return;
    }
    if (t.hasAttribute('data-msc-bd-add')) { e.preventDefault(); addVariant(t.getAttribute('data-msc-bd-add')); }
  });

  // Esc closes; Tab stays inside the drawer while it is open.
  document.addEventListener('keydown', function (e) {
    if (!isOpen()) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var p = panel();
    if (!p) return;
    var items = Array.prototype.filter.call(
      p.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'),
      function (n) { return n.offsetWidth || n.offsetHeight || n.getClientRects().length; }
    );
    if (!items.length) { e.preventDefault(); p.focus(); return; }
    var first = items[0], last = items[items.length - 1];
    if (!p.contains(document.activeElement)) { e.preventDefault(); first.focus(); return; }
    if (e.shiftKey && (document.activeElement === first || document.activeElement === p)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  // Back/forward cache can bring back an out-of-date basket.
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
})();
